import React, { useEffect, useState } from "react";
import axios from "axios";
import MainLogo from "../../../src/assets/image/main-logo.png";
import { useLocation } from "react-router-dom";
import Footer from "../superAdmin/footer/Footer";
import { useNavigate } from "react-router-dom";
import Dropdown from "react-bootstrap/Dropdown";
import Select from "react-select";
import { Spinner, Form, Row, Col, Card, Modal, Button } from "react-bootstrap";
import TokenUndefined from "../Service/TokenUndefined";
import { message } from "antd";
import FormatChecker from "../Service/FormatChecker";
import moment from "moment";
import { createRazorypayOrder } from "../Service/paymentForExtraMember.service";

function VisitorForm({
  formHeader,
  formName,
  editStatus,
  companyType,
  edit_name,
  edit_contact,
  edit_phone,
  edit_email,
  id,
  barcode,
  barcodeId,
}) {
  // Constants for stay options
  const oneNightOptions = [
    { value: "23rd", label: "23rd July" },
    { value: "24th", label: "24th July" },
    { value: "25th", label: "25th July" },
  ];

  const twoNightOptions = [
    { value: "23rd-25th", label: "23rd July - 25th July" },
    { value: "24th-26th", label: "24th July - 26th July" },
    { value: "25th-26th", label: "25th July - 26th July" },
  ];

  const travelModes = [
    { value: "Flight", label: "Flight" },
    { value: "Train", label: "Train" },
    { value: "Self", label: "Self" }
  ];

  let editName = edit_name === undefined ? "" : edit_name;
  let editContact = edit_contact === undefined ? "" : edit_contact;
  let editPhone = edit_phone === undefined ? "" : edit_phone;
  let editEmail = edit_email === undefined ? "" : edit_email;

  console.log(
    "sdasdadadadadads0",
    editName,
    editContact,
    editPhone,
    editEmail,
    companyType
  );
  const navigate = useNavigate();

  let currentLocation = useLocation().pathname;

  const designationArray = ["Owner", "Representative "];
  const visitingAsArray = [
    "Wholesaler",
    "Manufacturer",
    "Retailer",
    "Chain Store   ",
    "Agent/Broker",
  ];
  const [number, setNumber] = useState(editPhone);
  const [visitorName, setVisitorName] = useState(editContact);
  const [designation, setDesignation] = useState("");
  const [visitingCategory, setVisitingCategory] = useState("");
  const [visitingID, setVisitingID] = useState("");
  const [visiting_as, setVisiting_as] = useState("");
  const [yourCompany, setYourCompany] = useState();
  const [comapnyList, setComapnyList] = useState([]);
  const [invitedByCompany, setInvitedByCompany] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [email, setEmail] = useState(editEmail);
  const [postalCode, setPostalCode] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [streetAddress, setStreetAddress] = useState("");
  const [gender, setGender] = useState("");
  const [streetAddressTwo, setstreetAddressTwo] = useState("");
  const [country, setCountry] = useState("India");
  const [hearAbout, setHearAbout] = useState("");
  const [photo, setPhoto] = useState();
  const [photoPreview, setPhotoPreview] = useState(null);
  const [idProofFront, setIDProofFront] = useState(null);
  const [idProofFrontPreview, setIDProofFrontPreview] = useState(null);
  const [idProofBack, setIDProofBack] = useState();
  const [idProofBackPreview, setIDProofBackPreview] = useState(null);
  const [invitedCompanyName, setInvitedCompanyName] = useState(editName);
  const [visitingDay, setVisitingDay] = useState("");
  const [reload, setReload] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [exhibitorName, setExhibitorName] = useState("");
  const [photoStatus, setPhotoStatus] = useState(false);
  const [idFrontStatus, setIdFrontStatus] = useState(false);
  const [idBackStatus, setIdBackStatus] = useState(false);
  const [emailError, setEmailError] = useState("");
  const [gst_number, setGst_number] = useState("");
  const [showError, setShowError] = useState("");
  const [reloadShow, setReloadShow] = useState(false);
  const [duplicateError, setDuplicateError] = useState(false);

  const [currentStep, setCurrentStep] = useState(1);
  const [totalSteps] = useState(3);
  const [arrivalMode, setArrivalMode] = useState("");
  const [stayDuration, setStayDuration] = useState("1");
  const [stayDate, setStayDate] = useState(null);
  const [checkOutDate, setCheckOutDate] = useState(null);
  const [needsCab, setNeedsCab] = useState(false);
  const [visitorData, setVisitorData] = useState(null);
  const [ticketsFor, setTicketsFor] = useState("");
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const [preferredTravelTime, setPreferredTravelTime] = useState("");
  const [exhibitorId, setExhibitorId] = useState("");
  const [travelDate, setTravelDate] = useState("");
  const [remarksValue, setRemarksValue] = useState("");
  const [demoGstNumber, setDemoGstNumber] = useState(false);
  const [showExtraOwnerModal, setShowExtraOwnerModal] = useState(false);
  const [isPaymentTaken, setIsPaymentTaken] = useState(false);

  const travelTimeOptions = [
    { value: "Before 6 AM", label: "Before 6 AM" },
    { value: "6 AM to 9 AM", label: "6 AM to 9 AM" },
    { value: "9 AM to 12 PM", label: "9 AM to 12 PM" },
    { value: "12 PM to 3 PM", label: "12 PM to 3 PM" },
    { value: "3 PM to 6 PM", label: "3 PM to 6 PM" },
    { value: "After 6 PM", label: "After 6 PM" },
  ];

  const handleMobileNoChange = (e) => {
    const input = e.target.value;
    const numericValue = input.replace(/\D/g, "");
    const user_id=localStorage.getItem("user_id");
    console.log(user_id);
    setNumber(numericValue);

    if (
      numericValue.length === 10 &&
      (formName === "exhibitor_vip" ||
        formName === "exhibitor_owner" ||
        formName === "exhibitor_staff")
    ) {
      axios
        .get(
          `${process.env.REACT_APP_API_END_POINT}/check-is-number/${numericValue}/${formName}/${user_id}`
        )
        .then((resData) => {
          setDuplicateError(resData.data.status);
        });
      // step wise form
      if (formName === "exhibitor_vip" && !duplicateError) {
        axios
          .get(
            `${process.env.REACT_APP_API_END_POINT}/check-registration-status/${formName}/${numericValue}/${exhibitorId}`
          )
          .then((resData) => {
            if (resData.data.status) {
              if (resData.data.message === 'Visitor is not registered in the system') {
                axios
                  .get(`${process.env.REACT_APP_API_END_POINT}/form-status-exhibitor`, {
                    headers: {
                      token: localStorage.getItem("jff_token"),
                    },
                  })
                  .then(async (res) => {
                    if (!res.data.vipstatus) {
                      message.error("The limit to add new members has exhausted");

                      setTimeout(() => {
                        window.location.reload();
                      }, 1000);
                    }
                  });
              }

              const savedStep = resData.data.currentStep;
              setVisitorData(resData.data.data);
              if (savedStep > totalSteps) {
                message.info("You have already completed the registration process.");
              } else {
                setCurrentStep(savedStep);
                if (!resData.data.status) {
                  message.info(`Continuing from step ${savedStep}`);
                }
              }
            }
            else {
              message.error(resData.data.message);
            }
          })
          .catch((error) => {
            console.error("Error checking registration status:", error);
          });
      }
    }
  };

  const flightOptions = [
    { value: "Agartala", label: "Agartala (IXA)" },
    { value: "Agatti", label: "Agatti (AGX)" },
    { value: "Agra", label: "Agra (AGR)" },
    { value: "Ahmedabad", label: "Ahmedabad (AMD)" },
    { value: "Aizawl", label: "Aizawl (AJL)" },
    { value: "Amritsar", label: "Amritsar (ATQ)" },
    { value: "Aurangabad", label: "Aurangabad (IXU)" },
    { value: "Ayodhya", label: "Ayodhya (AYJ)" },
    { value: "Bagdogra", label: "Bagdogra (IXB)" },
    { value: "Bareilly", label: "Bareilly (BEK)" },
    { value: "Belagavi", label: "Belagavi (IXG)" },
    { value: "Bengaluru", label: "Bengaluru (BLR)" },
    { value: "Bhopal", label: "Bhopal (BHO)" },
    { value: "Bhubaneswar", label: "Bhubaneswar (BBI)" },
    { value: "Chandigarh", label: "Chandigarh (IXC)" },
    { value: "Chennai", label: "Chennai (MAA)" },
    { value: "Coimbatore", label: "Coimbatore (CJB)" },
    { value: "Darbhanga", label: "Darbhanga (DBR)" },
    { value: "Dehradun", label: "Dehradun (DED)" },
    { value: "Delhi", label: "Delhi (DEL)" },
    { value: "Deoghar", label: "Deoghar (DGH)" },
    { value: "Dharamshala", label: "Dharamshala (DHM)" },
    { value: "Dibrugarh", label: "Dibrugarh (DIB)" },
    { value: "Dimapur", label: "Dimapur (DMU)" },
    { value: "Diu", label: "Diu (DIU)" },
    { value: "Durgapur", label: "Durgapur (RDP)" },
    { value: "Gaya", label: "Gaya (GAY)" },
    { value: "Ghaziabad", label: "Ghaziabad (HDO)" },
    { value: "Goa", label: "Goa (GOI)" },
    { value: "Gondia", label: "Gondia (GDB)" },
    { value: "Gorakhpur", label: "Gorakhpur (GOP)" },
    { value: "Guwahati", label: "Guwahati (GAU)" },
    { value: "Gwalior", label: "Gwalior (GWL)" },
    { value: "Hirasar", label: "Hirasar (HSR)" },
    { value: "Hubli", label: "Hubli (HBX)" },
    { value: "Hyderabad", label: "Hyderabad (HYD)" },
    { value: "Imphal", label: "Imphal (IMF)" },
    { value: "Indore", label: "Indore (IDR)" },
    { value: "Itanagar", label: "Itanagar (HGI)" },
    { value: "Jabalpur", label: "Jabalpur (JLR)" },
    { value: "Jagdalpur", label: "Jagdalpur (JGB)" },
    { value: "Jaipur", label: "Jaipur (JAI)" },
    { value: "Jaisalmer", label: "Jaisalmer (JSA)" },
    { value: "Jammu", label: "Jammu (IXJ)" },
    { value: "Jharsuguda", label: "Jharsuguda (JRG)" },
    { value: "Jodhpur", label: "Jodhpur (JDH)" },
    { value: "Jorhat", label: "Jorhat (JRH)" },
    { value: "Kathmandu", label: "Kathmandu (KTM)"},
    { value: "Kadapa", label: "Kadapa (CDP)" },
    { value: "Kannur", label: "Kannur (CNN)" },
    { value: "Kanpur", label: "Kanpur (KNU)" },
    { value: "Khajuraho", label: "Khajuraho (HJR)" },
    { value: "Kochi", label: "Kochi (COK)" },
    { value: "Kolhapur", label: "Kolhapur (KLH)" },
    { value: "Kolkata", label: "Kolkata (CCU)" },
    { value: "Kozhikode", label: "Kozhikode (CCJ)" },
    { value: "Kurnool", label: "Kurnool (KJB)" },
    { value: "Leh", label: "Leh (IXL)" },
    { value: "Lucknow", label: "Lucknow (LKO)" },
    { value: "Madurai", label: "Madurai (IXM)" },
    { value: "Mangaluru", label: "Mangaluru (IXE)" },
    { value: "Mumbai", label: "Mumbai (BOM)" },
    { value: "Mysuru", label: "Mysuru (MYQ)" },
    { value: "Nagpur", label: "Nagpur (NAG)" },
    { value: "Nashik", label: "Nashik (ISK)" },
    { value: "North Goa", label: "North Goa (GOX)" },
    { value: "Pantnagar", label: "Pantnagar (PGH)" },
    { value: "Patna", label: "Patna (PAT)" },
    { value: "Port Blair", label: "Port Blair (IXZ)" },
    { value: "Prayagraj", label: "Prayagraj (IXD)" },
    { value: "Puducherry", label: "Puducherry (PNY)" },
    { value: "Pune", label: "Pune (PNQ)" },
    { value: "Raipur", label: "Raipur (RPR)" },
    { value: "Rajahmundry", label: "Rajahmundry (RJA)" },
    { value: "Rajkot", label: "Rajkot (RAJ)" },
    { value: "Ranchi", label: "Ranchi (IXR)" },
    { value: "Salem", label: "Salem (SXV)" },
    { value: "Shillong", label: "Shillong (SHL)" },
    { value: "Shirdi", label: "Shirdi (SAG)" },
    { value: "Shivamogga", label: "Shivamogga (RQY)" },
    { value: "Silchar", label: "Silchar (IXS)" },
    { value: "Srinagar", label: "Srinagar (SXR)" },
    { value: "Surat", label: "Surat (STV)" },
    { value: "Thiruvananthapuram", label: "Thiruvananthapuram (TRV)" },
    { value: "Tiruchirappalli", label: "Tiruchirappalli (TRZ)" },
    { value: "Tirupati", label: "Tirupati (TIR)" },
    { value: "Tuticorin", label: "Tuticorin (TCR)" },
    { value: "Udaipur", label: "Udaipur (UDR)" },
    { value: "Vadodara", label: "Vadodara (BDQ)" },
    { value: "Varanasi", label: "Varanasi (VNS)" },
    { value: "Vijayawada", label: "Vijayawada (VGA)" },
    { value: "Visakhapatnam", label: "Visakhapatnam (VTZ)" }
  ];
  const trainOptions = [
    { value: "Agartala", label: "Agartala" },
    { value: "Agatti", label: "Agatti" },
    { value: "Agra", label: "Agra" },
    { value: "Ahmedabad", label: "Ahmedabad" },
    { value: "Aizawl", label: "Aizawl" },
    { value: "Amritsar", label: "Amritsar" },
    { value: "Aurangabad", label: "Aurangabad" },
    { value: "Ayodhya", label: "Ayodhya" },
    { value: "Bagdogra", label: "Bagdogra" },
    { value: "Bareilly", label: "Bareilly" },
    { value: "Belagavi", label: "Belagavi" },
    { value: "Bengaluru", label: "Bengaluru" },
    { value: "Bhagalpur", label: "Bhagalpur(BGP)"},
    { value: "Bhopal", label: "Bhopal" },
    { value: "Bhubaneswar", label: "Bhubaneswar" },
    { value: "Chandigarh", label: "Chandigarh" },
    { value: "Chennai", label: "Chennai" },
    { value: "Coimbatore", label: "Coimbatore" },
    { value: "Darbhanga", label: "Darbhanga" },
    { value: "Dehradun", label: "Dehradun" },
    { value: "Delhi", label: "Delhi" },
    { value: "Deoghar", label: "Deoghar" },
    { value: "Dharamshala", label: "Dharamshala" },
    { value: "Dibrugarh", label: "Dibrugarh" },
    { value: "Dimapur", label: "Dimapur" },
    { value: "Diu", label: "Diu" },
    { value: "Durgapur", label: "Durgapur" },
    { value: "Gaya", label: "Gaya" },
    { value: "Goa", label: "Goa" },
    { value: "Gondia", label: "Gondia" },
    { value: "Gorakhpur", label: "Gorakhpur" },
    { value: "Guwahati", label: "Guwahati" },
    { value: "Gwalior", label: "Gwalior" },
    { value: "Hirasar", label: "Hirasar" },
    { value: "Hubli", label: "Hubli" },
    { value: "Hyderabad", label: "Hyderabad" },
    { value: "Imphal", label: "Imphal" },
    { value: "Indore", label: "Indore" },
    { value: "Itanagar", label: "Itanagar" },
    { value: "Jabalpur", label: "Jabalpur" },
    { value: "Jagdalpur", label: "Jagdalpur" },
    { value: "Jaipur", label: "Jaipur" },
    { value: "Jaisalmer", label: "Jaisalmer" },
    { value: "Jammu", label: "Jammu" },
    { value: "Jharsuguda", label: "Jharsuguda" },
    { value: "Jodhpur", label: "Jodhpur" },
    { value: "Jorhat", label: "Jorhat" },
    { value: "Kadapa", label: "Kadapa" },
    { value: "Kannur", label: "Kannur" },
    { value: "Kanpur", label: "Kanpur" },
    { value: "Khajuraho", label: "Khajuraho" },
    { value: "Kochi", label: "Kochi" },
    { value: "Kolhapur", label: "Kolhapur" },
    { value: "Kolkata", label: "Kolkata" },
    { value: "Kozhikode", label: "Kozhikode" },
    { value: "Kurnool", label: "Kurnool" },
    { value: "Leh", label: "Leh" },
    { value: "Lucknow", label: "Lucknow" },
    { value: "Madurai", label: "Madurai" },
    { value: "Mangaluru", label: "Mangaluru" },
    { value: "Mumbai", label: "Mumbai" },
    { value: "Mysuru", label: "Mysuru" },
    { value: "Nagpur", label: "Nagpur" },
    { value: "Nashik", label: "Nashik" },
    { value: "North Goa", label: "North Goa" },
    { value: "Pantnagar", label: "Pantnagar" },
    { value: "Patna", label: "Patna" },
    { value: "Port Blair", label: "Port Blair" },
    { value: "Prayagraj", label: "Prayagraj" },
    { value: "Puducherry", label: "Puducherry" },
    { value: "Pune", label: "Pune" },
    { value: "Raipur", label: "Raipur" },
    { value: "Rajahmundry", label: "Rajahmundry" },
    { value: "Rajkot", label: "Rajkot" },
    { value: "Ranchi", label: "Ranchi" },
    { value: "Salem", label: "Salem" },
    { value: "Satna", label: "Satna"},
    { value: "Shillong", label: "Shillong" },
    { value: "Shirdi", label: "Shirdi" },
    { value: "Shivamogga", label: "Shivamogga" },
    { value: "Silchar", label: "Silchar" },
    { value: "Srinagar", label: "Srinagar" },
    { value: "Surat", label: "Surat" },
    { value: "Thiruvananthapuram", label: "Thiruvananthapuram" },
    { value: "Tiruchirappalli", label: "Tiruchirappalli" },
    { value: "Tirupati", label: "Tirupati" },
    { value: "Tuticorin", label: "Tuticorin" },
    { value: "Udaipur", label: "Udaipur" },
    { value: "Vadodara", label: "Vadodara" },
    { value: "Varanasi", label: "Varanasi" },
    { value: "Vijayawada", label: "Vijayawada" },
    { value: "Visakhapatnam", label: "Visakhapatnam" }
  ];
  const trainStationOptions = [
    { value: "Howrah", label: "Howrah" },
    { value: "Sealdah", label: "Sealdah" },
    { value: "Shalimar", label: "Shalimar" },
    { value: "Kolkata", label: "Kolkata" },
  ];


  let formJson = {
    visitor: [
      "mobile",
      "visitor_name",
      "designation",
      "visiting_as",
      // "invited_company",
      "email",
      "street_add_line1",
      "street_add_line2",
      "city",
      "state",
      "zipcode",
      "country",
      "hduhear",
      "photo",
      "id_front",
      "id_back",
      // "visiting_day",
    ],
    exhibitor_owner: [
      "mobile",
      "visitor_name",
      // "designation",
      // "visiting_as",
      // "invited_company",
      // "email",
      // "street_add_line1",
      // "street_add_line2",
      // "city",
      // "state",
      // "zipcode",
      // "country",
      // "hduhear",
      "photo",
      // "id_front",
      // "id_back",
      // "visiting_day",
    ],
    exhibitor_staff: [
      "mobile",
      "visitor_name",
      // "designation",
      // "visiting_as",
      // "invited_company",
      // "email",
      // "street_add_line1",
      // "street_add_line2",
      // "city",
      // "state",
      // "zipcode",
      // "country",
      // "hduhear",
      "photo",
      // "id_front",
      // "id_back",
      // "visiting_day",
    ],
    exhibitor_modal: ["mobile", "visitor_name", "photo", "id_front", "id_back"],
    exhibitor_family: [
      "mobile",
      "visitor_name",
      "photo",
      "id_front",
      "id_back",
    ],
    exhibitor_vip: [
      "mobile",
      "visitor_name",
      "designation",
      // "visiting_as",
      // "invited_company",
      "email",
      "street_add_line1",
      "street_add_line2",
      "city",
      "gst_number",
      // "state",
      // "zipcode",
      // "country",
      // "hduhear",
      // "photo",
      // "id_front",
      // "id_back",
      // "visiting_day",
      "company_name",
    ],
    vendor_owner: [
      "mobile",
      "visitor_name",
      // "designation",
      // "visiting_as",
      // "invited_company",
      // "email",
      // "street_add_line1",
      // "street_add_line2",
      // "city",
      // "state",
      // "zipcode",
      // "country",
      // "hduhear",
      "photo",
      "id_front",
      "id_back",
      // "visiting_day",
    ],
    edit_update: [
      "visitor_name",
      "mobile",
      "invited_company",
      "email",
      "photo",
      "id_front",
      "id_back",
    ],
    edit_form_update: [
      "visitor_name",
      "mobile",
      "invited_company",
      "email",
      "photo",
      "id_front",
      "id_back",
    ],
    vendor_staff: [
      "mobile",
      "visitor_name",
      // "designation",
      // "visiting_as",
      // "invited_company",
      // "email",
      // "street_add_line1",
      // "street_add_line2",
      // "city",
      // "state",
      // "zipcode",
      // "country",
      // "hduhear",
      "photo",
      "id_front",
      "id_back",
      // "visiting_day",
    ],
  };
  function handlePhoto(e) {
    const file = e.target.files[0];
    if (file) {
      let dataStatus = FormatChecker(file);
      setPhotoStatus(dataStatus);
      if (!dataStatus) {
        setPhoto(file);
        setPhotoPreview(URL.createObjectURL(file));
      } else {
        message.error("please upload in the given format");
        setPhoto(null);
        setPhotoPreview(null);
      }
    } else {
      setPhoto(null);
      setPhotoPreview(null);
      setPhotoStatus(false);
    }
  }
  const handleName = (e) => {
    const newValue = e.target.value;
    const alphabetOnlyValue = newValue.replace(/[^A-Za-z ]/g, "");
    setVisitorName(alphabetOnlyValue);
  };
  const handleCompanyNameChange = (e) => {
    const newValue = e.target.value;
    const alphabetOnlyValue = newValue.replace(/[^A-Za-z ]/g, "");
    setCompanyName(alphabetOnlyValue);
  };
  const handleStreetAddressChange = (e) => {
    const newValue = e.target.value;
    const alphabetOnlyValue = newValue.replace(/[^A-Za-z0-9 ]/g, "");
    setStreetAddress(alphabetOnlyValue);
  };
  const handleCityChange = (e) => {
    const newValue = e.target.value;
    const alphabetOnlyValue = newValue.replace(/[^A-Za-z ]/g, "");
    setCity(alphabetOnlyValue);
  };
  const handleStateChange = (e) => {
    const newValue = e.target.value;
    const alphabetOnlyValue = newValue.replace(/[^A-Za-z ]/g, "");
    setState(alphabetOnlyValue);
  };
  const handlePostalCodeChange = (e) => {
    const newValue = e.target.value;
    const numericValue = newValue.replace(/\D/g, "");
    setPostalCode(numericValue);
  };
  const handleCountryChange = (e) => {
    const newValue = e.target.value;
    const alphabetOnlyValue = newValue.replace(/[^A-Za-z ]/g, "");
    setCountry(alphabetOnlyValue);
  };

  const regex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
  function checkRegex(input) {
    return regex.test(input);
  }

  function convertToUpperCase(input) {
    return input.replace(/[a-z]/gi, (char) => char.toUpperCase());
  }

  const handleGstNumberChange = (e) => {
    const convertedValue = convertToUpperCase(e.target.value);
    setGst_number(convertedValue);
    
    if (checkRegex(convertedValue)) {
      setShowError("");
    } else {
      setShowError("Provide Valid GSTIN");
    }
  };

  useEffect(() => {
    if (gst_number === '22AAAAA0000A1Z5') {
      setDemoGstNumber(true);
      return;
    }
    let timeout;
    if (gst_number.length === 15 && checkRegex(gst_number)) {
      // setReloadShow(true);
      // ;
    timeout = setTimeout(() => {
        axios
          .get(
            `${process.env.REACT_APP_API_END_POINT}/check-gst-validation/${gst_number}`
          )
        .then((resData) => {
          // setReloadShow(false);
          // console.log(
          //   "hello i am here to see the test daeeed",
          //   resData.data.message,
          //   resData.data.data.lgnm,
          //   resData.data.data.pradr.adr
          // );
          // if (resData.data.message === "GSTIN  found.") {
          console.log("gst find or not", resData.data);
          if (resData.data.flag === false) {
            setShowError(resData.data.message);
            return;
          }
          setDemoGstNumber(false);
          setShowError("");
          setCompanyName(resData.data.company);
          setStreetAddress(resData.data.address);
          setCity(resData.data.city);
          setPostalCode(resData.data.postalCode);
          setState(resData.data.state);
          // }
        });
      }, 400);
    }
    return () => clearTimeout(timeout);
  }, [gst_number]);

  // useEffect(() => {
  //   axios
  //     .post(
  //       `${process.env.REACT_APP_API_END_POINT}/visitor-category`,
  //       {
  //         id: visitingID,
  //       },
  //       {
  //         headers: {
  //           token: localStorage.getItem("token"),
  //         },
  //       }
  //     )
  //     .then((res) => {
  //       console.log("get-visitor", res.data.data);
  //       setAllCategory(res.data.data);
  //     });
  // }, []);

  function handleIDFront(e) {
    const file = e.target.files[0];
    if (file) {
      let dataStatus = FormatChecker(file);
      setIdFrontStatus(dataStatus);
      if (!dataStatus) {
        setIDProofFront(file);
        setIDProofFrontPreview(URL.createObjectURL(file));
      } else {
        message.error("please upload in the given format");
        setIDProofFront(null);
        setIDProofFrontPreview(null);
      }
    } else {
      setIDProofFront(null);
      setIDProofFrontPreview(null);
      setIdFrontStatus(false);
    }
  }
  function handleIDBack(e) {
    const file = e.target.files[0];
    if (file) {
      let dataStatus = FormatChecker(file);
      setIdBackStatus(dataStatus);
      if (!dataStatus) {
        setIDProofBack(file);
        setIDProofBackPreview(URL.createObjectURL(file));
      } else {
        message.error("please upload in the given format");
        setIDProofBack(null);
        setIDProofBackPreview(null);
      }
    } else {
      setIDProofBack(null);
      setIDProofBackPreview(null);
      setIdBackStatus(false);
    }
  }

  const handleEmailChange = (e) => {
    const value = e.target.value;
    setEmail(value);

    const emailPattern = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;

    if (!emailPattern.test(value)) {
      setEmailError("Invalid email format");
    } else {
      setEmailError("");
    }
  };

  useEffect(() => {
    emptyField();
  }, [reload]);

  useEffect(() => {
    if (
      formName === "vendor_owner" ||
      formName === "vendor_staff" ||
      companyType === "vendor"
    ) {
      axios
        .get(`${process.env.REACT_APP_API_END_POINT}/get-vendor-list`)
        .then((res) => {
          // console.log("assasdasaadads", res.data.data);
          setComapnyList(res.data.data);
        });
    } else {
      if (formName !== "vendor_staff" && formName !== "vendor_owner") {
        axios
          .get(`${process.env.REACT_APP_API_END_POINT}/get-exhibitor-list`, {
            headers: {
              token: localStorage.getItem("jff_token"),
            },
          })
          .then((res) => {
            // console.log("assasdasaadads", res.data.data);
            setInvitedByCompany(res?.data?.data);
          });
      }
    }
  }, [reload]);

  useEffect(() => {
    const userId = localStorage.getItem("user_id");
    if (formName !== "vendor_staff" && formName !== "vendor_owner") {
      TokenUndefined("exhibitor/login");
    }

    if (formName !== "vendor_staff" && formName !== "vendor_owner") {
      axios
        .post(`${process.env.REACT_APP_API_END_POINT}/get-exhibitor-name`, "", {
          headers: {
            token: localStorage.getItem("jff_token"),
          },
        })
        .then((res) => {
          // LoginRedirection(res, "exhibitor/login");
          setExhibitorName(res.data.data);
          setExhibitorId(res.data.exhibitor_id);
        })
        .catch((err) => {
          // LoginRedirection("/superadmin/login");

          // if (formName !== "vendor_staff" || formName !== "vendor_owner") {
          if (err.response.status === 401) {
            navigate("/exhibitor/login");
            localStorage.removeItem("jff_token");
            localStorage.removeItem("category");
            localStorage.removeItem("permission");
            localStorage.removeItem("user_id");
            localStorage.removeItem("type_of_user");
          }
          // }
        });
    }
  }, []);

  const handleNextStep = () => {
    if (currentStep < totalSteps) {

      handleSubmit();
    }
  };

  const handlePrevStep = () => {
    if (currentStep > 1) {
      axios
        .get(
          `${process.env.REACT_APP_API_END_POINT}/check-registration-status/${formName}/${number}/${exhibitorId}`
        )
        .then((resData) => {
          if (resData.data.status) {
            setVisitorData(resData.data.data);
          }
          setCurrentStep(currentStep - 1);
          setIsLoading(false);
        })
        .catch((error) => {
          console.error("Error fetching updated data:", error);
          setCurrentStep(currentStep - 1);
        });
    }
  };

  const validateStep = () => {
    switch (currentStep) {
      case 1:
        if (!gst_number || !visitorName || !email || !designation || !number || number.length < 10) {
          if (number.length < 10) {
            message.error("Please Enter 10 Digit Mobile Number");
            return false;
          }
          message.error("Please fill all required fields in step 1");
          return false;
        }
        break;
      case 2:
        if (!photo || !idProofFront || !idProofBack) {
          message.error("Please upload all required documents in step 2");
          return false;
        }
        break;
      case 3:
        if (!arrivalMode) {
          message.error("Please select arrival mode");
          return false;
        }

        if (arrivalMode !== "Self") {
          if (!ticketsFor) {
            message.error("Please select tickets for (Arrival/Departure)");
            return false;
          }

          if (!from) {
            message.error("Please select origin location");
            return false;
          }

          if (!to) {
            message.error("Please select destination location");
            return false;
          }

          if ((ticketsFor === "arrival" && travelDate < "2025-07-23") || (ticketsFor === "arrival" && travelDate > "2025-07-25")) {
            message.error("Travel date must be between 23rd and 25th July 2025");
            return false;
          }

          if (ticketsFor === "departure" && travelDate < "2025-07-24" || ticketsFor === "departure" && travelDate > "2025-07-27") {
            message.error("Travel date must be between 24th and 27th July 2025");
            return false;
          }
        }

        if (!stayDate || !stayDuration) {
          message.error("Please select stay date and stay duration");
          return false;
        }
        break;
      default:
        return true;
    }
    return true;
  };

  useEffect(() => {
    if (visitorData) {
      setVisitorName(visitorData.visitor_name || "");
      setNumber(visitorData.mobile_number || "");
      setEmail(visitorData.email || "");
      setDesignation(visitorData.designation || "");
      setCompanyName(visitorData.company_name || "");
      setGst_number(visitorData.gst_number || "");
      setStreetAddress(visitorData.street_address || "");
      setCity(visitorData.city || "");
      setState(visitorData.state || "");
      setGender(visitorData.gender || "");
      // For images, if visitorData has a string path, set the main state to that string
      // and the preview state to the full URL for display.
      // If the user uploads a new file, 'photo' will become a File object, 
      // and 'photoPreview' will be an object URL.
      if (visitorData.photo && typeof visitorData.photo === 'string') {
        setPhoto(visitorData.photo);
        setPhotoPreview(`${process.env.REACT_APP_IMAGE_URL}/photo/${visitorData.photo}?v=${moment().unix()}`);
        setPhotoStatus(false);
      } else if (visitorData.photo instanceof File) {
        setPhoto(visitorData.photo);
        setPhotoPreview(URL.createObjectURL(visitorData.photo));
        setPhotoStatus(false);
      }
      else {
        setPhoto(null);
        setPhotoPreview(null);
      }

      if (visitorData.id_proof_front && typeof visitorData.id_proof_front === 'string') {
        setIDProofFront(visitorData.id_proof_front);
        setIDProofFrontPreview(`${process.env.REACT_APP_IMAGE_URL}/id_proof/${visitorData.id_proof_front}?v=${moment().unix()}`);
        setIdFrontStatus(false);
      } else if (visitorData.id_proof_front instanceof File) {
        setIDProofFront(visitorData.id_proof_front);
        setIDProofFrontPreview(URL.createObjectURL(visitorData.id_proof_front));
        setIdFrontStatus(false);
      }
      else {
        setIDProofFront(null);
        setIDProofFrontPreview(null);
      }

      if (visitorData.id_proof_back && typeof visitorData.id_proof_back === 'string') {
        setIDProofBack(visitorData.id_proof_back);
        setIDProofBackPreview(`${process.env.REACT_APP_IMAGE_URL}/id_proof/${visitorData.id_proof_back}?v=${moment().unix()}`);
        setIdBackStatus(false);
      } else if (visitorData.id_proof_back instanceof File) {
        setIDProofBack(visitorData.id_proof_back);
        setIDProofBackPreview(URL.createObjectURL(visitorData.id_proof_back));
        setIdBackStatus(false);
      }
      else {
        setIDProofBack(null);
        setIDProofBackPreview(null);
      }

      if (visitorData.travel_info) {
        setArrivalMode(visitorData.travel_info.arrival_mode || "");
        setTicketsFor(visitorData.travel_info.tickets_for || "");
        setFrom(visitorData.travel_info.from || "");
        setTo(visitorData.travel_info.to || "");
        setStayDuration(visitorData.travel_info.stay_duration || "1");
        setStayDate(visitorData.travel_info.stay_date || null);
        const initialNeedsCab = visitorData.travel_info.needs_cab !== undefined
          ? visitorData.travel_info.needs_cab
          : (visitorData.travel_info.tickets_for === "arrival");
        setNeedsCab(initialNeedsCab);
        setPreferredTravelTime(visitorData.travel_info.preferred_travel_time || "");
        setTravelDate(visitorData.travel_info.travel_date || "");
        setRemarksValue(visitorData.remarks_value || "");
      }
    }
  }, [visitorData, currentStep]);

  const handleSubmit = async (e, paymentWasJustMade = false) => {
    if (e) {
      e.preventDefault();
    }
    setIsLoading(true);

    const effectivePaymentStatus = paymentWasJustMade || isPaymentTaken;

    if (formName === "exhibitor_vip") {
      if (!validateStep()) {
        setIsLoading(false);
        return;
      }

      try {
        const formData = new FormData();
        formData.append("mobile_number", number);
        formData.append("category", formName);
        formData.append("currentStep", currentStep.toString());
        formData.append("exhibitor_id", exhibitorId);

        if (currentStep === 1) {
          formData.append("visitor_name", visitorName);
          formData.append("email", email);
          formData.append("designation", designation);
          formData.append("company_name", companyName);
          formData.append("gst_number", gst_number);
          formData.append("street_address", streetAddress);
          formData.append("city", city);
          formData.append("state", state);
          formData.append("gender", gender);
          formData.append("postal_code", postalCode);
        } else if (currentStep === 2) {
          formData.append("photo", photo);
          formData.append("id_proof_front", idProofFront);
          formData.append("id_proof_back", idProofBack);
        } else if (currentStep === 3) {
          formData.append("arrival_mode", arrivalMode);
          if (arrivalMode !== "Self") {
            formData.append("tickets_for", ticketsFor || "");
            formData.append("from", from || "");
            formData.append("to", to || "");
            formData.append("preferred_travel_time", preferredTravelTime || "");
            formData.append("needs_cab", needsCab === null || needsCab === undefined ? (ticketsFor === "arrival" ? true : false) : needsCab);
            formData.append("travel_date", travelDate);
          }
          formData.append("stay_duration", stayDuration);
          formData.append("stay_date", stayDate);
          formData.append("remarks_value", remarksValue || "");
        }

        const response = await axios.post(
          `${process.env.REACT_APP_API_END_POINT}/add-visitor`,
          formData,
          {
            headers: {
              token: localStorage.getItem("jff_token"),
            }
          }
        );

        if (response.data.message === "Number already registered for another exhibitor" && response.data.status == false) {
          message.error(response.data.message);
          setIsLoading(false);
          return;
        }
        if (response.data.status == false) {
          message.error(response.data.message);
          setIsLoading(false);
          return;
        }

        if (response.data.messageData) {
          message.error(response.data.messageData);
          return;
        }

        if (currentStep < totalSteps) {
          message.success(`Step ${currentStep} completed successfully!`);
          setVisitorData(response.data.data);
          setCurrentStep(currentStep + 1);
        } else {
          message.success("Registration completed successfully!");
          navigate("/exhibitor/vip-guest-requrest-list");
        }

        return;
      } catch (error) {
        console.error("Error submitting form:", error);
        message.error("An error occurred. Please try again.");
        setIsLoading(false);
        return;
      } finally {
        setIsLoading(false);
      }
    }

    // form submission code for other categories
    const dataNeedTOCheck = await axios.get(
      `${process.env.REACT_APP_API_END_POINT}/form-status-exhibitor`,
      {
        headers: {
          token: localStorage.getItem("jff_token"),
        },
      }
    );
    if (formName === "exhibitor_owner" && !dataNeedTOCheck.data.ownerstatus) {
      message.error("The limit to add new members has exhausted");
      setIsLoading(false);

      return;
    }

    if (formName === "exhibitor_staff" && !dataNeedTOCheck.data.staffstatus && !effectivePaymentStatus) {
      setShowExtraOwnerModal(true);
      setIsLoading(false);
      return; 
    }
    if (formName === "exhibitor_vip" && !dataNeedTOCheck.data.vipstatus) {
      message.error("The limit to add new members has exhausted");
      setIsLoading(false);

      return;
    }

    //  formName !== "exhibitor_staff" &&
    // formName !== "exhibitor_vip"
    //  .then((res) => {
    //    console.log(res.data);
    //    if (res.data.staffstatus) {
    //      navigate("/exhibitor/exhibitor-staff-registration");
    //    } else {
    //      message.error("The limit to add new members has exhausted");
    //    }
    //  });

    if (!visitorName) {
      message.error("Name is required");
      setIsLoading(false);
    } else if (!number) {
      message.error("Phone Number is required");
      setIsLoading(false);
    } else if (number.length !== 10) {
      message.error("Please Enter 10 Digit Mobile Number");
      setIsLoading(false);
      return;
    } else if (emailError && formName !== "exhibitor_vip") {
      message.error("Invalid email format");
      setIsLoading(false);
      return;
    } else if (!companyName && formName === "exhibitor_vip") {
      message.error("Company Name is required");
      setIsLoading(false);
    } else if (!designation && formName === "exhibitor_vip") {
      message.error("Designation is required");
      setIsLoading(false);
    } else if (!city && formName === "exhibitor_vip") {
      message.error("City is required");
      setIsLoading(false);
    } else if (!country && formName === "exhibitor_vip") {
      message.error("Country is required");
      setIsLoading(false);
    } else if (!gst_number && formName === "exhibitor_vip") {
      message.error("Fill Valid Gst Number");
      setIsLoading(false);
    } else if (!photo && formName !== "exhibitor_vip") {
      message.error("Photo is required");
      setIsLoading(false);
    } else if (
      !idProofFront &&
      formName !== "exhibitor_owner" &&
      formName !== "exhibitor_staff" &&
      formName !== "exhibitor_vip"
    ) {
      message.error("ID Proof Front is required");
      setIsLoading(false);
    } else if (
      !idProofBack &&
      formName !== "exhibitor_owner" &&
      formName !== "exhibitor_staff" &&
      formName !== "exhibitor_vip"
    ) {
      message.error("ID Proof Back is required");
      setIsLoading(false);
    } else {
      if (editStatus) {
        // if (number.length !== 10) {
        //   message.error("Please Enter 10 Digit Mobile Number");
        //   setIsLoading(false);
        //   return;
        // }
        // if (emailError) {
        //   message.error("Invalid email format");
        //   setIsLoading(false);
        //   return;
        // }
        e.preventDefault();
        const formData = new FormData();
        formData.append("visitor_name", visitorName);
        formData.append("email", email);
        formData.append("company_name", companyName);
        formData.append("mobile_number", number);
        formData.append("invited_exhibitor_id", invitedByCompany);
        formData.append("photo", photo);
        formData.append("id_proof_front", idProofFront);
        formData.append("id_proof_back", idProofBack);
        formData.append("id", id);

        axios
          .post(
            `${process.env.REACT_APP_API_END_POINT}/update-visitor`,
            formData,
            {
              headers: {
                token: `${localStorage.getItem("jff_token")}`,
                barcode,
              },
            }
          )
          .then((res) => {
            if (res.data.messageData) {
              message.error(res.data.messageData);
              setIsLoading(false);
              emptyField();
            } else {
              window.location.reload(true);
              // setReload(!reload)
              // message.success("Form Submit Successfully");
              window.alert("Form Submit Successfully");
              setIsLoading(false);
            }
          })
          .catch((error) => {
            console.error("Axios Error:", error);
          });
      } else {
        // {
        if (!photo && !idProofFront && !idProofBack) {
          axios
            .post(
              `${process.env.REACT_APP_API_END_POINT}/add-visitor`,
              {
                mobile_number: number,
                visitor_name: visitorName,
                designation: designation,
                visiting_as: visiting_as,
                firm_id: yourCompany,
                invited_exhibitor_id: invitedByCompany,
                email: email,
                company_name: companyName,
                street_address: streetAddress,
                street_address_two: streetAddressTwo,
                city: city,
                gst_number,
                state: state,
                postal_code: postalCode,
                country: country,
                hear_about_jff: hearAbout,
                category: formName,
                visiting_day: visitingDay,
                visitor_category_id: visitingID,
                barcodeId,
              },
              {
                headers: {
                  token: localStorage.getItem("jff_token"),
                },
              }
            )
            .then((res) => {
              // setReload(!reload)
              // window.location.reload(true);
              // message.success("Form Submit Successfully");
              if (res.data.messageData) {
                message.error(res.data.messageData);
                setIsLoading(false);
                emptyField();
              } else {
                window.alert("Form Submit Successfully");
                setIsLoading(false);
                window.location.reload(true);
                if (formName === "exhibitor_owner") {
                  // console.log("anisdsdif", formName);
                  navigate("/exhibitor/owner-list");
                } else if (formName === "exhibitor_staff") {
                  // console.log("anisdsdif", formName);
                  navigate("/exhibitor/staff-list");
                } else if (formName === "exhibitor_modal") {
                  navigate("/exhibitor/modal-list");
                } else if (formName === "exhibitor_family") {
                  navigate("/exhibitor/family-list");
                } else if (formName === "exhibitor_vip") {
                  // console.log("anisdsdif", formName);
                  navigate("/exhibitor/vip-guest-requrest-list");
                }
              }
            })
            .catch((err) => {
              // LoginRedirection("/superadmin/login");
              setIsLoading(false);
              if (err.response.status === 401) {
                navigate("/superadmin/login");
                localStorage.removeItem("jff_token");
                localStorage.removeItem("category");
                localStorage.removeItem("permission");
                localStorage.removeItem("user_id");
                localStorage.removeItem("type_of_user");
              }
            });
        } else {
          const formData = new FormData();
          formData.append("mobile_number", number);
          formData.append("visitor_name", visitorName);
          formData.append("designation", designation);
          formData.append("visiting_as", visiting_as);
          formData.append("firm_id", yourCompany);
          formData.append("invited_exhibitor_id", invitedByCompany);
          formData.append("email", email);
          formData.append("company_name", companyName);
          formData.append("street_address", streetAddress);
          formData.append("street_address_two", streetAddressTwo);
          formData.append("city", city);
          formData.append("state", state);
          formData.append("postal_code", postalCode);
          formData.append("country", country);
          formData.append("hear_about_jff", hearAbout);
          formData.append("photo", photo);
          formData.append("id_proof_front", idProofFront);
          formData.append("id_proof_back", idProofBack);
          formData.append("category", formName);
          formData.append("visiting_day", visitingDay);
          formData.append("visitor_category_id", visitingID);
          formData.append("barcodeId", barcodeId);
          if (effectivePaymentStatus && formName === "exhibitor_staff") {
            formData.append("additional_staff_member", true);
          }
          axios
            .post(
              `${process.env.REACT_APP_API_END_POINT}/add-visitor`,
              formData,
              {
                headers: {
                  token: localStorage.getItem("jff_token"),
                },
              }
            )
            .then(async (res) => {
              // setReload(!reload)
              // window.location.reload(true);
              // message.success("Form Submit Successfully");
              emptyField();
              if (res.data.message.extra_staff_member == "false") {
                const onPaymentSuccess = () => {
                  setIsLoading(false);
                  emptyField();
                  message.success(res.data.message);
                  window.location.reload(true);
                  setIsLoading(false);
                };
                
                await createRazorypayOrder(
                  1180,
                  res.data.message.barcode,
                  res.data.message.mobile_number || "0000000000",
                  res.data.message.email || "test@gmail.com",
                  res.data.message.visitor_name || "test",
                  onPaymentSuccess
                );
                
              } else {
                window.alert("Form Submit Successfully");
                setIsLoading(false);
                window.location.reload(true);
                // console.log("anisdsd", formName);
                if (formName === "exhibitor_owner") {
                  // console.log("anisdsdif", formName);
                  navigate("/exhibitor/owner-list");
                } else if (formName === "exhibitor_staff") {
                  // console.log("anisdsdif", formName);
                  navigate("/exhibitor/staff-list");
                } else if (formName === "exhibitor_modal") {
                  navigate("/exhibitor/modal-list");
                } else if (formName === "exhibitor_family") {
                  navigate("/exhibitor/family-list");
                } else if (formName === "exhibitor_vip") {
                  // console.log("anisdsdif", formName);
                  navigate("/exhibitor/vip-guest-requrest-list");
                }
              }
            })
            .catch((err) => {
              // LoginRedirection("/superadmin/login");
              setIsLoading(false);
              if (err.response.status === 401) {
                navigate("/superadmin/login");
                localStorage.removeItem("jff_token");
                localStorage.removeItem("category");
                localStorage.removeItem("permission");
                localStorage.removeItem("user_id");
                localStorage.removeItem("type_of_user");
              }
            });
        }
        // }
      }
    }
  };
  const emptyField = () => {
    setGst_number("");
    setVisitorName("");
    setNumber("");
    setEmail("");
    setCompanyName("");
    setDesignation("");
    setYourCompany("");
    setVisiting_as("");
    setStreetAddress("");
    setstreetAddressTwo("");
    setCity("");
    setState("");
    setPostalCode("");
    // setCountrsy("");
    setHearAbout("");
    setPhoto("");
    setIDProofFront(null);
    setIDProofBack("");
    setInvitedByCompany("");
    setVisitingCategory("");
    setVisitingID("");
    setInvitedCompanyName("");
    setVisitingDay("");
    setStayDuration("");
    setStayDate(null);
    setPreferredTravelTime("");
    setIsPaymentTaken(false); 
  };

  // Add step content components
  const renderStep1 = () => (
    <div>
      <h5 className="mb-4">Step 1: Basic Information</h5>
      <Row>
        <Col lg={6} md={6} className="mb-3">
          <Form.Group>
            <Form.Label className="fw-bold">
              Mobile Number <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              placeholder="Mobile No."
              value={number}
              maxLength={10}
              onChange={handleMobileNoChange}
            />
            {duplicateError && (
              <Form.Text className="text-danger" style={{ fontSize: "10px" }}>
                This number is already registered
              </Form.Text>
            )}
          </Form.Group>
        </Col>
        <Col lg={6} md={6} className="mb-3">
          <Form.Group>
            <Form.Label className="fw-bold">
              GST Number <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              value={gst_number}
              maxLength={15}
              placeholder="GST Number"
              onChange={handleGstNumberChange}
            />
            {showError && <Form.Text className="text-danger">{showError}</Form.Text>}
          </Form.Group>
        </Col>
        <Col lg={6} md={6} className="mb-3">
          <Form.Group>
            <Form.Label className="fw-bold">
              Name <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              placeholder="Name"
              value={visitorName}
              maxLength={100}
              onChange={handleName}
            />
          </Form.Group>
        </Col>
        <Col lg={6} md={6} className="mb-3">
          <Form.Group>
            <Form.Label className="fw-bold">
              Company Name
            </Form.Label>
            <Form.Control
              value={companyName}
              maxLength={40}
              placeholder="Company Name"
              onChange={handleCompanyNameChange}
              readOnly={!demoGstNumber}
            />
          </Form.Group>
        </Col>
        <Col lg={6} md={6} className="mb-3">
          <Form.Group>
            <Form.Label className="fw-bold">
              Email <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              placeholder="Email"
              value={email}
              onChange={handleEmailChange}
            />
            {emailError && <Form.Text className="text-danger">{emailError}</Form.Text>}
          </Form.Group>
        </Col>
        <Col lg={6} md={6} className="mb-3">
          <Form.Group>
            <Form.Label className="fw-bold">
              Gender <span className="text-danger">*</span>
            </Form.Label>
            <Select
              options={[
                { value: "Male", label: "Male" },
                { value: "Female", label: "Female" }
              ]}
              value={gender ? { value: gender, label: gender } : null}
              onChange={(selectedOption) => {
                const newGender = selectedOption ? selectedOption.value : null;
                setGender(newGender);
              }}
              isSearchable
              placeholder="Select gender"
              required={true}
            />
          </Form.Group>
        </Col>
        <Col lg={6} md={6} className="mb-3">
          <Form.Group>
            <Form.Label className="fw-bold">
              Designation <span className="text-danger">*</span>
            </Form.Label>
            <Select
              options={designationArray.map((data) => ({
                value: data,
                label: data,
              }))}
              value={designation ? { value: designation, label: designation } : null}
              onChange={(selectedOption) =>
                setDesignation(selectedOption ? selectedOption.value : null)
              }
              isSearchable
              placeholder="Select designation"
            />
          </Form.Group>
        </Col>

        <Col lg={6} md={6} className="mb-3">
          <Form.Group>
            <Form.Label className="fw-bold">
              Address <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              placeholder="Address"
              value={streetAddress}
              maxLength={150}
              onChange={handleStreetAddressChange}
              readOnly={!demoGstNumber}
            />
          </Form.Group>
        </Col>
        <Col lg={6} md={6} className="mb-3">
          <Form.Group>
            <Form.Label className="fw-bold">
              Pin Code
            </Form.Label>
            <Form.Control
              placeholder="Pin Code"
              value={postalCode}
              maxLength={100}
              onChange={handlePostalCodeChange}
              readOnly={!demoGstNumber}
            />
          </Form.Group>
        </Col>
        <Col lg={6} md={6} className="mb-3">
          <Form.Group>
            <Form.Label className="fw-bold">
              City
            </Form.Label>
            <Form.Control
              placeholder="City"
              value={city}
              maxLength={100}
              onChange={handleCityChange}
              readOnly={!demoGstNumber}
            />
          </Form.Group>
        </Col>
        <Col lg={6} md={6} className="mb-3">
          <Form.Group>
            <Form.Label className="fw-bold">
              State
            </Form.Label>
            <Form.Control
              placeholder="State"
              value={state}
              maxLength={100}
              onChange={handleStateChange}
              readOnly={!demoGstNumber}
            />
          </Form.Group>
        </Col>
      </Row>
    </div>
  );

  const renderStep2 = () => (
    <div>
      <h5 className="mb-4">Step 2: Document Upload</h5>
      <Row>
        <Col lg={6} md={6} className="mb-3">
          <Form.Group>
            <Form.Label className="fw-bold">
              Upload Photo <span className="text-danger">*</span>
              {photoStatus && (
                <Form.Text className="text-danger d-block">
                  Only supported (JPG/JPEG/PNG)
                </Form.Text>
              )}
            </Form.Label>
            <Form.Control
              type="file"
              onChange={handlePhoto}
              accept=".jpg, .jpeg, .png"
            />
            {photoPreview ? (
              <div className="mt-2">
                <img
                  loading="lazy"
                  src={photoPreview}
                  alt="User"
                  style={{ width: '100px', height: '100px', objectFit: 'cover' }}
                />
              </div>
            ) : photo ? (
              <div className="mt-2">
                <img
                  src={`${process.env.REACT_APP_IMAGE_URL}/photo/${photo}?v=${moment().unix()}`}
                  alt="User"
                  style={{ width: '100px', height: '100px', objectFit: 'cover' }}
                />
              </div>
            ) : <span>-</span>}
          </Form.Group>
        </Col>
        <Col lg={6} md={6} className="mb-3">
          <Form.Group>
            <Form.Label className="fw-bold">
              Aadhaar Card (Front) <span className="text-danger">*</span>
              {idFrontStatus && (
                <Form.Text className="text-danger d-block">
                  Only supported (JPG/JPEG/PNG)
                </Form.Text>
              )}
            </Form.Label>
            <Form.Control
              type="file"
              onChange={handleIDFront}
              accept=".jpg, .jpeg, .png"
            />
            {idProofFrontPreview ? (
              <div className="mt-2">
                <img
                  src={idProofFrontPreview}
                  alt="Preview"
                  style={{ width: '100px', height: '100px', objectFit: 'cover' }}
                />
              </div>
            ) : idProofFront ? (
              <div className="mt-2">
                <img
                  src={`${process.env.REACT_APP_IMAGE_URL}/id_proof/${idProofFront}?v=${moment().unix()}`}
                  alt="ID Front"
                  style={{ width: '100px', height: '100px', objectFit: 'cover' }}
                />
              </div>
            ) : <span>-</span>}
          </Form.Group>
        </Col>
        <Col lg={6} md={6} className="mb-3">
          <Form.Group>
            <Form.Label className="fw-bold">
              Aadhaar Card (Back) <span className="text-danger">*</span>
              {idBackStatus && (
                <Form.Text className="text-danger d-block">
                  Only supported (JPG/JPEG/PNG)
                </Form.Text>
              )}
            </Form.Label>
            <Form.Control
              type="file"
              onChange={handleIDBack}
              accept=".jpg, .jpeg, .png"
            />
            {idProofBackPreview ? (
              <div className="mt-2">
                <img
                  src={idProofBackPreview}
                  alt="Preview"
                  style={{ width: '100px', height: '100px', objectFit: 'cover' }}
                />
              </div>
            ) : idProofBack ? (
              <div className="mt-2">
                <img
                  className="img-size"
                  src={`${process.env.REACT_APP_IMAGE_URL}/id_proof/${idProofBack}?v=${moment().unix()}`}
                  alt="ID Front"
                  style={{ width: '100px', height: '100px', objectFit: 'cover' }}
                />
              </div>
            ) : <span>-</span>}
          </Form.Group>
        </Col>
      </Row>
    </div>
  );

  const renderStep3 = () => (
    <div>
      <h5 className="mb-4">Step 3: Travel Information</h5>
      <Row>
        <Col lg={6} md={6} className="mb-3">
          <Form.Group>
            <Form.Label className="fw-bold">
              Travel Mode <span className="text-danger">*</span>
            </Form.Label>
            <Select
              options={travelModes}
              value={arrivalMode ? { value: arrivalMode, label: arrivalMode } : null}
              onChange={(selectedOption) => {
                setArrivalMode(selectedOption ? selectedOption.value : null);
                setTravelDate("");
              }}
              isSearchable
              placeholder="Select arrival mode"
              required={true}
            />
          </Form.Group>
        </Col>
        {arrivalMode !== "Self" && <Col lg={6} md={6} className="mb-3">
          <Form.Group>
            <Form.Label className="fw-bold">
              Tickets for (Arrival/Departure) <span className="text-danger">*</span>
            </Form.Label>
            <Select
              options={[
                { value: "arrival", label: "Arrival" },
                { value: "departure", label: "Departure" }
              ]}
              value={ticketsFor ? { value: ticketsFor, label: ticketsFor.charAt(0).toUpperCase() + ticketsFor.slice(1) } : null}
              onChange={(selectedOption) => {
                const newTicketsFor = selectedOption ? selectedOption.value : null;
                setTicketsFor(newTicketsFor);
                setTravelDate("");

                if (newTicketsFor === "arrival" && arrivalMode !== "Self") {
                  setTo("Kolkata");
                  setNeedsCab(true);
                } else if (newTicketsFor === "departure" && arrivalMode !== "Self") {
                  setFrom("Kolkata");
                  setNeedsCab(false);
                }
              }}
              isSearchable
              placeholder="Select tickets for"
              required={true}
            />
          </Form.Group>
        </Col>}
        {arrivalMode !== "Self" && <Col lg={6} md={6} className="mb-3">
          <Form.Group>
            <Form.Label className="fw-bold">
              From <span className="text-danger">*</span>
            </Form.Label>
            {ticketsFor === 'arrival' && (arrivalMode === 'Flight' || arrivalMode === 'Train') ? (
              <Select
                options={arrivalMode === 'Flight' ? flightOptions : trainOptions}
                value={(arrivalMode === 'Flight' ? flightOptions : trainOptions).find(option => option.value === from)}
                onChange={(selectedOption) => {
                  setFrom(selectedOption ? selectedOption.value : null);
                  setTravelDate("");
                }}
                isSearchable
                placeholder={`Select ${arrivalMode === 'Flight' ? 'origin airport' : 'origin station'}`}
                required={true}
              />
            ) : ticketsFor === 'departure' && arrivalMode === 'Train' ? (
              <Select
                options={trainStationOptions}
                value={trainStationOptions.find(option => option.value === from)}
                onChange={(selectedOption) => {
                  setFrom(selectedOption ? selectedOption.value : null);
                  setTo("");
                  setTravelDate("");
                }}
                isSearchable
                placeholder="Select origin station"
                required={true}
              />
            ) : (
              <Form.Control
                placeholder="From"
                value={from}
                maxLength={100}
                onChange={(e) => {
                  setFrom(e.target.value);
                  setTo("");
                  setTravelDate("");
                }}
                required={true}
                readOnly={ticketsFor === 'departure' || arrivalMode === "Self"}
              />
            )}
          </Form.Group>
        </Col>}
        {arrivalMode !== "Self" && <Col lg={6} md={6} className="mb-3">
          <Form.Group>
            <Form.Label className="fw-bold">
              To <span className="text-danger">*</span>
            </Form.Label>
            {ticketsFor === 'departure' && (arrivalMode === 'Flight' || arrivalMode === 'Train') ? (
              <Select
                options={arrivalMode === 'Flight' ? flightOptions : trainOptions}
                value={(arrivalMode === 'Flight' ? flightOptions : trainOptions).find(option => option.value === to)}
                onChange={(selectedOption) => {
                  setTo(selectedOption ? selectedOption.value : null);
                  setTravelDate("");
                }}
                isSearchable
                placeholder={`Select ${arrivalMode === 'Flight' ? 'destination airport' : 'destination station'}`}
                required={true}
              />
            ) : ticketsFor === 'arrival' && arrivalMode === 'Train' ? (
              <Select
                options={trainStationOptions}
                value={trainStationOptions.find(option => option.value === to)}
                onChange={(selectedOption) => {
                  setTo(selectedOption ? selectedOption.value : null);
                  setFrom("");
                  setTravelDate("");
                }}
                isSearchable
                placeholder="Select destination station"
                required={true}
              />
            ) : (
              <Form.Control
                placeholder="To"
                value={to}
                maxLength={100}
                onChange={(e) => {
                  setTo(e.target.value);
                  setFrom("");
                  setTravelDate("");
                }}
                required={true}
                readOnly={ticketsFor === 'arrival' || arrivalMode === "Self"}
              />
            )}
          </Form.Group>
        </Col>}

        {arrivalMode !== "Self" && (
          <Col lg={6} md={6} className="mb-3">
            <Form.Group>
              <Form.Label className="fw-bold">
                Preferred Travel Time <span className="text-danger">*</span>
              </Form.Label>
              <Select
                options={travelTimeOptions}
                value={preferredTravelTime ? { value: preferredTravelTime, label: preferredTravelTime } : null}
                onChange={(selectedOption) =>
                  setPreferredTravelTime(selectedOption ? selectedOption.value : null)
                }
                isSearchable
                placeholder="Select preferred travel time"
                required={true}
              />
            </Form.Group>
          </Col>
        )}
        <Col lg={6} md={6} className="mb-3">
          <Form.Group>
            <Form.Label className="fw-bold">
              Stay Duration <span className="text-danger">*</span>
            </Form.Label>
            <Select
              options={[
                { value: "1", label: "1 Night" },
                { value: "2", label: "2 Nights" }
              ]}
              value={stayDuration ? { value: stayDuration, label: `${stayDuration} Night${stayDuration === "2" ? "s" : ""}` } : null}
              onChange={(selectedOption) => {
                setStayDuration(selectedOption ? selectedOption.value : null);
                setStayDate("");
              }
              }
              isSearchable
              placeholder="Select stay duration"
              required={true}
            />
          </Form.Group>
        </Col>
        <Col lg={6} md={6} className="mb-3">
          <Form.Group>
            <Form.Label className="fw-bold">
              Stay Date <span className="text-danger">*</span>
            </Form.Label>
            <Select
              options={stayDuration === "1" ? oneNightOptions : twoNightOptions}
              value={stayDate ? { value: stayDate, label: stayDate } : null}
              onChange={(selectedOption) =>
                setStayDate(selectedOption ? selectedOption.value : null)
              }
              isSearchable
              placeholder="Select stay date"
              required={true}
            />
          </Form.Group>
        </Col>
        <Col lg={6} md={6} className="mb-3">
          <Form.Group>
            <Form.Label className="fw-bold">
              Travel Date <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              type="date"
              value={travelDate}
              onChange={(e) => setTravelDate(e.target.value)}
              required
              min={ticketsFor === 'arrival' ? '2025-07-23' : '2025-07-24'}
              max={ticketsFor === 'arrival' ? '2025-07-25' : '2025-07-27'}
            />
          </Form.Group>
        </Col>

        {(arrivalMode !== "Self" && travelDate !== "2025-07-27") && <Col lg={6} md={6} className="mb-3">
          <Form.Group>
            <Form.Label className="fw-bold">
              Need cab facility? <span className="text-danger">*</span>
            </Form.Label>
            <div className="d-flex gap-3">
              <Form.Check
                type="radio"
                id="needsCabYes"
                label="Yes"
                checked={needsCab === true}
                onChange={() => setNeedsCab(true)}
              />
              <Form.Check
                type="radio"
                id="needsCabNo"
                label="No"
                checked={needsCab === false}
                onChange={() => setNeedsCab(false)}
              />
            </div>
          </Form.Group>
        </Col>}
        <Col lg={6} md={6} className="mb-3">
          <Form.Group>
            <Form.Label className="fw-bold">Remarks (Optional)</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              value={remarksValue}
              onChange={(e) => setRemarksValue(e.target.value)}
              placeholder="Enter any additional notes or remarks"
            />
          </Form.Group>
        </Col>
      </Row>
      <ul className="mt-2">
        <li className="">
          <small className="text-danger">
            We will be providing one-way tickets.
          </small>
        </li>
        <li>
          <small className="text-danger">
            Hotel stay will be a maximum of two nights.
          </small>
        </li>
      </ul>
    </div>
  );

  return (
    <>
      <div className="text-center">
        <h4 className="form-heading">{formHeader}</h4>
      </div>

      <section>
        <div className="container">
          <div className="form-body-section">
            <div className="form-body">

              {formName === "exhibitor_vip" ? (
                <>
                  {currentStep === 1 && renderStep1()}
                  {currentStep === 2 && renderStep2()}
                  {currentStep === 3 && renderStep3()}
                </>
              ) : (
                <div>
                  {formJson[formName]?.includes("mobile") && (
                    <Form.Group as={Row} className="mb-3" controlId="formPlaintextMobile">
                      <Form.Label column sm="4">
                        Mobile No.<span className="text-danger">*</span>
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control
                          type="text"
                          required
                          value={number}
                          onChange={handleMobileNoChange}
                          maxLength={10}
                          placeholder="Enter 10 digit Mobile Number"
                        />
                        {duplicateError && (
                          <span style={{ color: "red" }}>Mobile number already exist</span>
                        )}
                      </Col>
                    </Form.Group>
                  )}
                  {formJson[formName]?.includes("visitor_name") && (
                    <Form.Group as={Row} className="mb-3" controlId="formPlaintextVisitorName">
                      <Form.Label column sm="4">
                        Name<span className="text-danger">*</span>
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control
                          type="text"
                          required
                          placeholder="Name"
                          value={visitorName}
                          maxLength={100}
                          onChange={handleName}
                        />
                      </Col>
                    </Form.Group>
                  )}
                  {formJson[formName]?.includes("photo") && (
                    <Form.Group as={Row} className="mb-3" controlId="formPlaintextPhoto">
                      <Form.Label column sm="4">
                        Upload Photo<span className="text-danger">*</span>
                        {photoStatus && (
                          <Form.Text className="text-danger d-block ms-2"> {/* ms-2 for slight indent */}
                            Only supported (JPG/JPEG/PNG)
                          </Form.Text>
                        )}
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control
                          type="file"
                          required
                          onChange={handlePhoto}
                          accept=".jpg, .jpeg, .png"
                        />
                        {photoPreview && (
                          <div className="mt-2">
                            <img
                              loading="lazy"
                              src={photoPreview}
                              alt="Photo Preview"
                              style={{ width: '100px', height: '100px', objectFit: 'cover' }}
                            />
                          </div>
                        )}
                      </Col>
                    </Form.Group>
                  )}
                </div>
              )}

              {formName === "exhibitor_vip" && (
                <div className="form-submit d-flex justify-content-between mt-4">
                  {currentStep > 1 && (
                    <Button
                      onClick={handlePrevStep}
                      variant="outline-secondary"
                      disabled={isLoading}
                    >
                      Previous
                    </Button>
                  )}
                  {currentStep < totalSteps ? (
                    <Button
                      onClick={handleNextStep}
                      variant="outline-primary"
                      disabled={isLoading}
                    >
                      {isLoading ? (
                        <Spinner animation="border" size="sm" />
                      ) : (
                        "Next"
                      )}
                    </Button>
                  ) : (
                    <Button
                      onClick={handleSubmit}
                      variant="outline-primary"
                      disabled={isLoading || duplicateError}
                    >
                      {isLoading ? (
                        <Spinner animation="border" size="sm" />
                      ) : (
                        "Submit"
                      )}
                    </Button>
                  )}
                </div>
              )}

              {formName !== "exhibitor_vip" && (
                <div className="form-submit d-flex justify-content-end mt-4">
                  <Button
                    onClick={handleSubmit}
                    variant="outline-primary"
                    disabled={isLoading || duplicateError}
                  >
                    {isLoading ? (
                      <Spinner animation="border" size="sm" />
                    ) : (
                      "Submit"
                    )}
                  </Button>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
      <Footer />
        <Modal centered show={showExtraOwnerModal} onHide={() => setShowExtraOwnerModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Limit Exceeded</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>The limit to add new members has exhausted</p>
            <p>If you want to add more members, You need to Pay Rs 1180/- per Member</p>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="outline-dark" onClick={()=>{
              setShowExtraOwnerModal(false);
              handleSubmit(null, true);
            }}>
              Pay Now
            </Button>
            <Button variant="outline-danger" onClick={() => setShowExtraOwnerModal(false)}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
    </>
  );
}

export default VisitorForm;
